import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ClipboardList, UtensilsCrossed, BookOpen } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const PROFILE_SECTIONS = [
  {
    icon: ClipboardList,
    label: 'Formularios de Salud',
    description: 'Comparte formularios con tus clientes',
    path: '/distributor/profile/forms',
    color: '#EF4444',
    gradient: 'from-red-500 to-rose-500',
  },
  {
    icon: UtensilsCrossed,
    label: 'Configurador de Dietas',
    description: 'Crea planes nutricionales personalizados',
    path: '/distributor/profile/diet-configurator',
    color: '#467322',
    gradient: 'from-emerald-500 to-green-500',
  },
  {
    icon: BookOpen,
    label: 'Dietas Guardadas',
    description: 'Gestiona y asigna dietas a tus clientes',
    path: '/distributor/profile/diets',
    color: '#2563EB',
    gradient: 'from-blue-500 to-indigo-500',
  },
];

const DistributorProfilePage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="max-w-2xl mx-auto space-y-5 animate-fade-in pb-4" data-testid="distributor-profile-page">
      <div className="pt-1">
        <h1 className="text-3xl font-bold text-gray-900" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
          Mi Perfil
        </h1>
        <p className="text-sm text-gray-400 mt-1 font-medium">Configuracion y herramientas</p>
      </div>

      {/* Profile card */}
      <div className="bg-gradient-to-br from-violet-500 to-purple-600 rounded-3xl p-5 text-white shadow-lg shadow-violet-500/20" data-testid="distributor-profile-card">
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 rounded-2xl bg-white/20 backdrop-blur flex items-center justify-center flex-shrink-0">
            <span className="text-3xl font-bold">{user?.name?.charAt(0)?.toUpperCase()}</span>
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-bold text-xl truncate" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>{user?.name}</p>
            {user?.display_id && (
              <span className="inline-block text-xs bg-white/20 backdrop-blur rounded-full px-3 py-0.5 mt-1 font-mono">
                {user.display_id}
              </span>
            )}
            <p className="text-xs text-white/70 mt-1">{user?.email}</p>
          </div>
        </div>
      </div>

      {/* Sections */}
      <div className="space-y-3">
        {PROFILE_SECTIONS.map((section, idx) => {
          const IconComp = section.icon;
          return (
            <button
              key={section.path}
              onClick={() => navigate(section.path)}
              className="w-full bg-white rounded-2xl border border-gray-100/50 p-4 text-left shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 group"
              style={{ animationDelay: `${idx * 60}ms` }}
              data-testid={`profile-section-${section.label.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <div className="flex items-center gap-4">
                <div
                  className={`rounded-2xl bg-gradient-to-br ${section.gradient} flex items-center justify-center shadow-lg flex-shrink-0 group-hover:scale-105 transition-transform duration-300`}
                  style={{ width: '52px', height: '52px', boxShadow: `0 4px 14px ${section.color}30` }}
                >
                  <IconComp size={24} className="text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-bold text-gray-900 text-sm" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
                    {section.label}
                  </p>
                  <p className="text-xs text-gray-400 mt-0.5">{section.description}</p>
                </div>
                <div className="text-gray-300 group-hover:text-gray-500 transition-colors">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6"/></svg>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default DistributorProfilePage;
